import type { DeleteCourseDraft401DetailsItem } from './deleteCourseDraft401DetailsItem';

/**
 * 에러 응답
 */
export type DeleteCourseDraft401 = {
  /**
   * 세부 에러 정보
   * @nullable
   */
  details?: DeleteCourseDraft401DetailsItem[] | null;
  /** 에러 코드 */
  error: string;
  /** 에러 메시지 */
  message: string;
  /** 요청 경로 */
  path?: string;
  /** 에러 발생 시간 */
  timestamp: string;
};
